export default __webpack_public_path__ + "static/media/cartracking3.f403be6f.png";